interface VermietetesObjektAdresse {
  plz: string;
  ort: string;
  strasse: string;
  hausnummer: string;
  vorbelegt?: boolean;
  auslaendischeAdresse?: boolean;
}

export interface VermietetesBasisObjekt extends VermietetesObjektAdresse {
  grundstueckBebaut: VermietetesObjektEnum.BASIS;
}

export interface VermietetesBebautesObjekt extends VermietetesObjektAdresse {
  grundstueckBebaut: VermietetesObjektEnum.BEBAUT;
  wohneinheiten: number;
  bruttojahresmieteWohneinheiten?: number;
  gewerbeeinheiten: number;
  bruttojahresmieteGewerbeeinheiten?: number;
  stellplaetze: number;
  bruttojahresmieteStellplaetze?: number;
  deltafaktorGarage?: number;
  deltafaktorGewerbe?: number;
  deltafaktorWohnung?: number;
  plzFaktorGarage?: number;
  plzFaktorGewerbe?: number;
  plzFaktorWohnung?: number;
  instanzIdGarage?: number;
  instanzIdGewerbe?: number;
  instanzIdWohnung?: number;
  auslaendischeAdresse?: boolean;
}

export interface VermietetesUnbebautesObjekt extends VermietetesObjektAdresse {
  grundstueckBebaut: VermietetesObjektEnum.UNBEBAUT;
  grundstueckFlaeche: number;
  flurstueckNummer: string;
  deltafaktorUnbebaut?: number;
  plzFaktorUnbebaut?: number;
  instanzIdUnbebaut?: number;
}

export enum VermietetesObjektEnum {
  BASIS,
  BEBAUT,
  UNBEBAUT,
}

export type VermietetesObjekt = VermietetesBebautesObjekt | VermietetesUnbebautesObjekt;
